import React, { memo, useCallback, useState } from 'react';

import { Box, IconButton, Popover } from '@mui/material';
import { AddReactionIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { TEAM_CHAT_REACTION_EMOJIS } from '../TeamChat.constants';

import EmojiButton from './components/EmojiButton';
import { POPOVER_ANCHOR_ORIGIN } from './TeamChatReactionPicker.constants';
import { pickerRootStyles } from './TeamChatReactionPicker.styles';
import { TeamChatReactionPickerTestIds } from './TeamChatReactionPicker.testIds';

const TeamChatReactionPicker = memo(({ onSelect = null, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpen = useCallback(e => {
    setAnchorEl(e.currentTarget);
  }, []);

  const onClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onEmojiSelect = useCallback(
    emoji => {
      onSelect?.(emoji);
      setAnchorEl(null);
    },
    [onSelect],
  );

  return (
    <>
      <IconButton
        data-testid={TeamChatReactionPickerTestIds.PICKER_BUTTON}
        disabled={disabled}
        size="small"
        onClick={onOpen}
      >
        <AddReactionIcon size={IconSize[20]} />
      </IconButton>
      <Popover
        disablePortal
        anchorEl={anchorEl}
        anchorOrigin={POPOVER_ANCHOR_ORIGIN}
        open={!!anchorEl}
        onClose={onClose}
      >
        <Box sx={pickerRootStyles}>
          {TEAM_CHAT_REACTION_EMOJIS.map((emoji, index) => (
            <EmojiButton
              dataTestId={TeamChatReactionPickerTestIds.getEmojiButtonId(index)}
              emoji={emoji}
              key={emoji}
              onSelect={onEmojiSelect}
            />
          ))}
        </Box>
      </Popover>
    </>
  );
});
TeamChatReactionPicker.propTypes = {
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default TeamChatReactionPicker;
